import { createSelector } from 'reselect'

const getEquipment = state => state.equipment
const getInventory = state => state.inventory

const getAllEquipedItemIDs = createSelector(
    getEquipment,
    equipment => (
        Object.values(equipment).reduce((arr, item) => {
            arr.push(item.itemID)
            return arr
        }, [])
    )
)
const getAvailableItems = createSelector(
    getAllEquipedItemIDs,
    getInventory,
    (allEquipedItemIDs, inventory) => inventory
        .filter(entry => !allEquipedItemIDs.includes(entry.ID))
        .sort((a, b) => {
            if (a.source < b.source) { return -1 }
            if (a.source > b.source) { return 1 }
            return 0
        })
)

export default getAvailableItems
